import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const StudentsTab = ({ enrolledStudents }) => {
  const studentColumns = [
    { field: 'firstName', headerName: 'First Name', width: 250 },
    { field: 'lastName', headerName: 'Last Name', width: 250 },
    { field: 'email', headerName: 'Email', width: 300 },
    { field: 'cell', headerName: 'Cellphone Number', width: 200 },
    { field: 'age', headerName: 'Age', width: 100 },
    { field: 'grade', headerName: 'Grade', width: 100 },
    { field: 'dueToUs', headerName: 'Outstanding Amount', width: 100 },
    { field: 'dueToYou', headerName: 'Student Credit', width: 100 },
  ];

  return (
    <Box mt={3}>
      <DataGrid
        rows={enrolledStudents.filter((row) => row.id)}
        columns={studentColumns}
        initialState={{ pagination: { paginationModel: { pageSize: 5 } } }}
        pageSizeOptions={[5, 10, 20]}
        autoHeight
      />
    </Box>
  );
};

export default StudentsTab;